import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";

export function Disclaimer({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();
  if (compact) {
    return (
      <p className="text-xs text-muted-foreground">
        {t("aDisclaimer.compact")}
      </p>
    );
  }
  return (
    <div className="rounded-xl border border-border bg-muted/40 p-4 text-sm text-muted-foreground">
      <div className="flex items-start gap-3">
        <Info className="h-5 w-5 mt-0.5 text-accent shrink-0" />
        <div className="space-y-2">
          <p><strong className="text-foreground">{t("aDisclaimer.title")}</strong>{t("aDisclaimer.body1")}</p>
          <p>{t("aDisclaimer.body2")}</p>
          <p>{t("aDisclaimer.body3")}</p>
        </div>
      </div>
    </div>
  );
}
